import { Grid, Link, Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect } from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Web3 from "web3";
import DashboardList from "../DashboardList";
import Loader from "../ErroBook/loader";

// set variables about the bounds 
import tokenLogo from "../../images/telegram.png"
import NtError from "../ErroBook/ntErro";
var BoundName = 'Liquidity Bond'
var web3;
var deciConvert = 1e18;
var deciConvertNine = 1e9;
var BondAdd;
var BondAbi;
var BondContract
var calcBondAdd;
var calcBondAbi;
var calcBondContract
var LPAdd;
var LPAbi;
var LPContract

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: 900,
    boxShadow: 24,
    borderRadius: 5,
  };
const DashboardTogetherCard = (props) => {
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState('1');

    
    const [useDefaultAccount, setDefaultAccount] = useState();
    const [useUserBalance, setUserBalance] = useState('0');
    const [useTokenBalance, setTokenBalance] = useState('0');
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    // States for this page
    const [useShowWalltetButton, setShowWalltetButton] = useState(true);
    const [useNextReward, setNextReward] = useState();
    const [useRewardYield, setRewardYield] = useState();
    const [useYouWillGet, setYouWillGet] = useState('0');
    const [useDynamicYouWillGet, setDynamicYouWillGet] = useState('0');
    const [useMaxYouCanBuy, setMaxYouCanBuy] = useState('0');
    const [useMaxYouCanBuyNoDivident, setMaxYouCanBuyNoDivident] = useState('0');
    const [useDebtRatio, setDebtRatio] = useState('0');
    const [useVestingTerm, setVestingTerm] = useState('0');
    const [useRoi, setRoi] = useState('0');
    const [usePrice, setPrice] = useState('0');
    const [useTotalDebt, setTotalDebt] = useState('0');
    const [useAmount, setAmount] = useState('0')
    const [useAmountError, setAmountError] = useState()
    const [useApprove, setApprove] = useState(true)

    useEffect(()=> {
        connectWallet();
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[useError,useErrorType]);

    

    /***************************************************
    *
    *    Numaric amount function
    *
    ****************************************************/
    const numaricAmount = (num,digit) => {
        return Number.parseFloat(num).toFixed(digit);
    }
    
    /***************************************************
    *
    *    update account, will cause component re-render
    *
    ****************************************************/
	const accountChangedHandler = (newAccount) => {
		setDefaultAccount(newAccount);
	}

    // Change network handling 
    try {
        window.ethereum.on('chainChanged', (_chainId => {
            if ( _chainId == "0x38") {
                console.log('you are on BSC', _chainId)
                window.location.reload();
            }else if ( _chainId == "0x61") {
                console.log('you are on BSC Test Net', _chainId)
                window.location.reload();
            }else{
                console.log('Wrong network Connected', _chainId)
                setErrorType('wrongNetwork')
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Updated Address error ', error)
    }

    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            accountChangedHandler(_mAddress.toString())
            setErrorType('walletChanged')
            setError(true)
            console.log('Updated Address ', _mAddress)
        }));
       
    } catch (error) {
        console.log('Updated Address error ', error)
    }
    /*******
    *
    *    Connecting Metamask
    *    Creating Contract object
    *    Save Wallet address in varibale
    *
    ******/

    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){
            web3 = new Web3(window.ethereum);
           
            //Bond Contract
            BondAdd = "0x2f9aaD14Bd484FdCFBF5ae4686872BE8Ce605F04";
            BondAbi = [{"inputs":[{"internalType":"address","name":"_LOVE","type":"address"},{"internalType":"address","name":"_principle","type":"address"},{"internalType":"address","name":"_treasury","type":"address"},{"internalType":"address","name":"_DAO","type":"address"},{"internalType":"address","name":"_bondCalculator","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"deposit","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"payout","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"expires","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"priceInUSD","type":"uint256"}],"name":"BondCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"priceInUSD","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"internalPrice","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"debtRatio","type":"uint256"}],"name":"BondPriceChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"recipient","type":"address"},{"indexed":false,"internalType":"uint256","name":"payout","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"remaining","type":"uint256"}],"name":"BondRedeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"initialBCV","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newBCV","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"adjustment","type":"uint256"},{"indexed":false,"internalType":"bool","name":"addition","type":"bool"}],"name":"ControlVariableAdjustment","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"inputs":[],"name":"DAO","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"LOVE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"adjustment","outputs":[{"internalType":"bool","name":"add","type":"bool"},{"internalType":"uint256","name":"rate","type":"uint256"},{"internalType":"uint256","name":"target","type":"uint256"},{"internalType":"uint256","name":"buffer","type":"uint256"},{"internalType":"uint256","name":"lastBlock","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"bondCalculator","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"bondInfo","outputs":[{"internalType":"uint256","name":"payout","type":"uint256"},{"internalType":"uint256","name":"vesting","type":"uint256"},{"internalType":"uint256","name":"lastBlock","type":"uint256"},{"internalType":"uint256","name":"pricePaid","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"bondPremium","outputs":[{"internalType":"uint256","name":"premium_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"bondPrice","outputs":[{"internalType":"uint256","name":"price_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"bondPriceInUSD","outputs":[{"internalType":"uint256","name":"price_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"currentDebt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"debtDecay","outputs":[{"internalType":"uint256","name":"decay_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"debtRatio","outputs":[{"internalType":"uint256","name":"debtRatio_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_maxPrice","type":"uint256"},{"internalType":"address","name":"_depositor","type":"address"}],"name":"deposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_controlVariable","type":"uint256"},{"internalType":"uint256","name":"_vestingTerm","type":"uint256"},{"internalType":"uint256","name":"_minimumPrice","type":"uint256"},{"internalType":"uint256","name":"_maxPayout","type":"uint256"},{"internalType":"uint256","name":"_fee","type":"uint256"},{"internalType":"uint256","name":"_maxDebt","type":"uint256"},{"internalType":"uint256","name":"_initialDebt","type":"uint256"}],"name":"initializeBondTerms","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isLiquidityBond","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastDecay","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxPayout","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_value","type":"uint256"}],"name":"payoutFor","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_depositor","type":"address"}],"name":"pendingPayoutFor","outputs":[{"internalType":"uint256","name":"pendingPayout_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_depositor","type":"address"}],"name":"percentVestedFor","outputs":[{"internalType":"uint256","name":"percentVested_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"policy","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"principle","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"pushManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"recoverLostToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_recipient","type":"address"},{"internalType":"bool","name":"_stake","type":"bool"}],"name":"redeem","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_addition","type":"bool"},{"internalType":"uint256","name":"_increment","type":"uint256"},{"internalType":"uint256","name":"_target","type":"uint256"},{"internalType":"uint256","name":"_buffer","type":"uint256"}],"name":"setAdjustment","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum BondDepositoryLP.PARAMETER","name":"_parameter","type":"uint8"},{"internalType":"uint256","name":"_input","type":"uint256"}],"name":"setBondTerms","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_staking","type":"address"},{"internalType":"bool","name":"_helper","type":"bool"}],"name":"setStaking","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"staking","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"stakingHelper","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"standardizedDebtRatio","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"terms","outputs":[{"internalType":"uint256","name":"controlVariable","type":"uint256"},{"internalType":"uint256","name":"vestingTerm","type":"uint256"},{"internalType":"uint256","name":"minimumPrice","type":"uint256"},{"internalType":"uint256","name":"maxPayout","type":"uint256"},{"internalType":"uint256","name":"fee","type":"uint256"},{"internalType":"uint256","name":"maxDebt","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalDebt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"treasury","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"useHelper","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}]
            BondContract = new web3.eth.Contract( BondAbi , BondAdd );
            
            LPAdd = "0xc05b35a5a86a67f1b2823a4e4af5c85e2a6dc5bc"
            LPAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}]
            LPContract = new web3.eth.Contract( LPAbi , LPAdd );
            
            calcBondAdd = "0xE9195ADD0e3ec376712e2F46D1Fb16147f257dd9"
            calcBondAbi = [{"inputs":[{"internalType":"address","name":"_LOVE","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"LOVE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_pair","type":"address"}],"name":"getKValue","outputs":[{"internalType":"uint256","name":"k_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_pair","type":"address"}],"name":"getTotalValue","outputs":[{"internalType":"uint256","name":"_value","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_pair","type":"address"}],"name":"markdown","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_pair","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"valuation","outputs":[{"internalType":"uint256","name":"_value","type":"uint256"}],"stateMutability":"view","type":"function"}]
            calcBondContract = new web3.eth.Contract( calcBondAbi , calcBondAdd );

            //get connected wallet address
            try {
                let userBal;
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    accountChangedHandler(_account.toString());
                    setShowWalltetButton(false)
                    // BondContract.methods.balanceOf(_account.toString()).call().then( result => {
                    //     console.log("symbole: ",result)
                    // })
                    // .catch (error => {
                    //     console.log('user Balance', error)
                    // })
                    BondContract.methods.pendingPayoutFor(_account.toString()).call().then( result => {
                        setYouWillGet(numaricAmount(result/deciConvertNine,4))
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                    })
                    BondContract.methods.terms().call().then( result => {
                        setVestingTerm(numaricAmount(result[1]/86400,2))
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                    })
                    BondContract.methods.debtRatio().call().then( result => {
                        setDebtRatio(numaricAmount(result/deciConvertNine,4))
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                    })
                    LPContract.methods.balanceOf(_account.toString()).call().then( result => {
                        setUserBalance(numaricAmount(result/deciConvert,4))
                        setTokenBalance((result/deciConvert))
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                    })
                    LPContract.methods.allowance(_account.toString(),BondAdd).call().then( result => {
                        if( result > 1 ){
                            setApprove(false)
                        }else{
                            setApprove(true)
                        }  
                    })
                })
                .catch (error => {
                    console.log('user accountChangedHandler', error.code)

                    if(error.code == '4001'){
                        setErrorType('metamaskReject')
                        setError(true)
                    }else{
                        setErrorType('walletNotConnected')
                        setShowWalltetButton(true)
                        setError(true)
                    }
                });
            } catch (error) {
                console.log('Rejected.! ')
            }
            BondContract.methods.bondPriceInUSD().call().then( result => {
                setPrice(numaricAmount(result/deciConvert,2))
            })
            .catch (error => {
                console.log('user Balance: ', error)
            });
            
            BondContract.methods.totalDebt().call().then( result => {
                setTotalDebt(numaricAmount(result/deciConvertNine,2))
            })
            .catch (error => {
                console.log('user Balance', error)
            })
            fetch('https://api.coingecko.com/api/v3/coins/solana').then(result => {
                result.json().then(data => {
                    let MPrice = data.market_data.current_price.usd;
                    if (usePrice != 0) {
                        let tpercDiff = ((usePrice-MPrice)/MPrice)*500
                        setRoi(numaricAmount(tpercDiff,2))
                    }
                    
                })
            });
            

        }else{
            console.log('Please install metamask to use this page.!')
        }
    }

    const handleAmount = (val,type) => {
        if( type == 'srch'){
          let valuea = val.target.value.toLowerCase();
          setAmount(valuea)
          if(valuea > useTokenBalance){
            setAmountError(true)
          }else if(valuea <= 0){
            setAmountError(true)
          }else{
            let convertedamounttostr1 = valuea.toString()
            let bondPrice = web3.utils.toWei(convertedamounttostr1, 'ether')
            // getting max-min amount for the bond
            calcBondContract.methods.valuation(LPAdd,bondPrice).call().then( valuationRes => {
                BondContract.methods.payoutFor(valuationRes).call().then( payoutForRes => {
                    BondContract.methods.maxPayout().call().then( maxPayoutRes => {
                        // console.log('user valuation', valuationRes)
                        let varPayoutFor = payoutForRes / Math.pow(10, 9)
                        let varMaxPayout = maxPayoutRes / Math.pow(10, 9)
                        if ( payoutForRes < 10000000 ) {
                            setAmountError(true)
                            console.log('Payout is smaller then 1000000')
                            setDynamicYouWillGet(0)
                            // return;
                        } else if ( varPayoutFor > varMaxPayout ) {
                            setAmountError(true)
                            console.log('Payout is greater then max')
                            setDynamicYouWillGet(0)
                            // return;
                        }else {
                            setAmountError(false)
                            setDynamicYouWillGet(numaricAmount(varPayoutFor,4))
                            console.log('Payout is looks fine')
                        }
                    })
                })
            })
          }
        }else{
          setAmount(val)
          if(val > useTokenBalance){
            setAmountError(true)
          }else if(val <= 0){
            setAmountError(true)
          }else{
            let convertedamounttostr1 = val.toString()
            let bondPrice = web3.utils.toWei(convertedamounttostr1, 'ether')
            // getting max-min amount for the bond
            calcBondContract.methods.valuation(LPAdd,bondPrice).call().then( valuationRes => {
                BondContract.methods.payoutFor(valuationRes).call().then( payoutForRes => {
                    BondContract.methods.maxPayout().call().then( maxPayoutRes => {
                        // console.log('user valuation', valuationRes)
                        let varPayoutFor = payoutForRes / Math.pow(10, 9)
                        let varMaxPayout = maxPayoutRes / Math.pow(10, 9)
                        if ( payoutForRes < 10000000 ) {
                            setAmountError(true)
                            console.log('Payout is smaller then 1000000')
                            setDynamicYouWillGet(0)
                            // return;
                        } else if ( varPayoutFor > varMaxPayout ) {
                            setAmountError(true)
                            console.log('Payout is greater then max')
                            setDynamicYouWillGet(0)
                            // return;
                        }else {
                            setAmountError(false)
                            setDynamicYouWillGet(numaricAmount(varPayoutFor,4))
                            console.log('Payout is looks fine')
                        }
                    })
                })
            })
          }
        }
    }
    const handleApprove = () => { 
        setLoader(true)
        LPContract.methods.approve(BondAdd, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
        .send({from: useDefaultAccount}).then( test => {
            LPContract.methods.allowance(useDefaultAccount,BondAdd).call().then( result => {
                if( result > 1 ){
                    setApprove(false)
                }else{
                    setApprove(true)
                }    
                window.location.reload();
                setLoader(false)       
          })
        })
        .catch(error => {
            setLoader(false)
            if(error.code == '4001'){
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
            console.log('Error getting fake data 1234: ' , error);
        });
    
    }
    const handleBond = () => {
        if (useAmount == "" || isNaN(useAmount)){
            setAmountError(true)
            return;
        }
        if(useAmount > useTokenBalance){
            setAmountError(true)
            return;
        }else if(useAmount <= 0){
            setAmountError(true)
            return;
        }
        // useMaxYouCanBuyNoDivident
        let convertedamounttostr1 = useAmount.toString()
        let bondPrice = web3.utils.toWei(convertedamounttostr1, 'ether')

        // getting max-min amount for the bond
        calcBondContract.methods.valuation(LPAdd,bondPrice).call().then( valuationRes => {
            BondContract.methods.payoutFor(valuationRes).call().then( payoutForRes => {
                BondContract.methods.maxPayout().call().then( maxPayoutRes => {
                    // console.log('user valuation', valuationRes)
                    let varPayoutFor = payoutForRes / Math.pow(10, 9)
                    let varMaxPayout = maxPayoutRes / Math.pow(10, 9)
                    if ( payoutForRes < 10000000 ) {
                        setAmountError(true)
                        console.log('Payout is smaller then 1000000')
                        setDynamicYouWillGet(0)
                        return;
                    } else if ( varPayoutFor > varMaxPayout ) {
                        setAmountError(true)
                        console.log('Payout is greater then max')
                        setDynamicYouWillGet(0)
                        return;
                    }else {
                        setAmountError(false)
                        setLoader(true);
                        console.log('Payout is looks fine')
                        BondContract.methods.deposit( bondPrice, bondPrice+1, useDefaultAccount )
                        .send({ from: useDefaultAccount }).then( result => {
                            setLoader(false);
                            window.location.reload();
                        })
                        .catch(error => {
                            setLoader(false)
                            if (error.code == '4001') {
                                setErrorType('metamaskReject')
                                setError(true)
                            }else{
                                setErrorType('someThingelse')
                                setError(true)
                            }
                            console.log('Error getting fake data 1234: ' , error);
                        });
                    }
                })
            })
        })
        // calcBondContract.methods.valuation(LPAdd,bondPrice).call().then( valuationRes => {
        //     BondContract.methods.payoutFor(valuationRes).call().then( payoutForRes => {
        //         BondContract.methods.maxPayout().call().then( maxPayoutRes => {
        //             console.log('user valuation', valuationRes)
        //             console.log('user payoutForRes', payoutForRes/1e9)
        //             console.log('user maxPayoutRes', maxPayoutRes)
                    
        //             if ( payoutForRes > maxPayoutRes ) {
        //                 console.log('Payout is greater then max')
        //                 return;
        //             } else if ( payoutForRes < 10000000 ) {
        //                 console.log('Payout is smaller then 1000000')
        //                 return;
        //             }else {
        //                 setDynamicYouWillGet(numaricAmount(payoutForRes/1e9,2))
        //                 console.log('Payout is looks fine')
        //                 BondContract.methods.deposit( bondPrice, bondPrice+1, useDefaultAccount )
        //                 .send({ from: useDefaultAccount }).then( result => {
        //                     setLoader(false);
        //                     window.location.reload();
        //                 })
        //                 .catch(error => {
        //                     setLoader(false)
        //                     if (error.code == '4001') {
        //                         setErrorType('metamaskReject')
        //                         setError(true)
        //                     }else{
        //                         setErrorType('someThingelse')
        //                         setError(true)
        //                     }
        //                     console.log('Error getting fake data 1234: ' , error);
        //                 });
        //             }
        //         })
        //     })
        // })
        // .catch (error => {
        //     console.log('user Balance', error)
        // })
        // BondContract.methods.payoutFor(bondPrice).call().then( result => {
        //     console.log('payoutFor', result + " // " + result/1e9)
        //     console.log('useMaxYouCanBuy', useMaxYouCanBuyNoDivident + " // " + useMaxYouCanBuyNoDivident/1e9)
        //     if ( useMaxYouCanBuyNoDivident <= result ) {
        //         console.log('fine value')
        //     } else {
        //         console.log('Not fine value')
        //     }
        // })
        // .catch (error => {
        //     console.log('user Balance', error)
        // })
        // let MaxBondPrice = web3.utils.toWei(convertedamounttostr1, 'ether')
        // console.log('bondPrice : ',bondPrice-1)
        // console.log('MaxBondPrice : ',MaxBondPrice)
        // setLoader(true);
        // BondContract.methods.deposit( bondPrice, MaxBondPrice+1, useDefaultAccount )
        // .send({ from: useDefaultAccount }).then( result => {
        //     setLoader(false);
        //     window.location.reload();
        // })
        // .catch(error => {
        //     setLoader(false)
        //     if (error.code == '4001') {
        //         setErrorType('metamaskReject')
        //         setError(true)
        //     }else{
        //         setErrorType('someThingelse')
        //         setError(true)
        //     }
        //     console.log('Error getting fake data 1234: ' , error);
        // });
    }

    const handleClaim = () => {
        setLoader(true);
        BondContract.methods.redeem( useDefaultAccount ,  false)
        .send({ from: useDefaultAccount }).then( result => {
            setLoader(false);
            window.location.reload();
        })
        .catch(error => {
            setLoader(false)
            if (error.code == '4001') {
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
            console.log('Error getting fake data 1234: ' , error);
        });
    }
    
    const handleClaimAutoStake = () => {
        setLoader(true);
        BondContract.methods.redeem( useDefaultAccount , true)
        .send({ from: useDefaultAccount }).then( result => {
            setLoader(false);
            window.location.reload();
        })
        .catch(error => {
            setLoader(false)
            if (error.code == '4001') {
                setErrorType('metamaskReject')
                setError(true)
            }else{
                setErrorType('someThingelse')
                setError(true)
            }
            console.log('Error getting fake data 1234: ' , error);
        });
    }
    const handleOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <Grid
            container
            xs={12}
            lg={8}
            justifyContent="center"
            alignContent="center"
            className="mx-auto my-2 pb-2"
            style={{borderBottom:'1px solid #565656'}}
        >
            {useError ?
                <NtError 
                    errorType = {useErrorType}
                />
            :
                <span />
            }
            { useLoader ? 
                <Loader />
            :
                <span />
            }
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
                direction="row"
            >
                <img src={tokenLogo} className="img-fluid" style={{maxWidth:35}} />
            </Grid>
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
            >
                <h6 className="mb-0">{BoundName}</h6>
            </Grid>
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
            >
                <p className="mb-0">{usePrice}</p>
            </Grid>
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
            >
                <p className="mb-0">{useRoi + "%"}</p>
            </Grid>
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
            >
                <p className="mb-0">{useTotalDebt}</p>
            </Grid>
            <Grid
                xs={12}
                sm={2}
                alignSelf="center"
            >
                <Link 
                    href="#"
                    onClick={handleOpen} 
                    className="Global---menu-nav-btn d-inline-block px-4 py-2 mx-1"
                >
                    Bond
                </Link>
            </Grid>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style}}>
                    <Grid
                        container
                        xs={12}
                        className="Dasboard-card-radius py-4 px-3 mt-5 px-md-5"
                    >
                        <Grid
                            xs={12}
                        >
                            <h2>{BoundName}</h2>
                        </Grid>
                        {useShowWalltetButton ? 
                            <Grid
                                xs={12}
                                className="text-center my-5 pt-5 pb-5"
                            >
                                <Link href="#" onClick={connectWallet} className="Global---menu-nav-btn px-5 py-2 mx-1">
                                    Connect Wallet
                                </Link>
                            </Grid>
                        :
                            <Grid
                                xs={12}
                                sm={8}
                                md={10}
                                className="mx-auto text-center pt-5 pb-4"
                            >
                                <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList 
                                        onChange={handleChangeTab} 
                                        aria-label="lab API tabs example"
                                        className="OS---stake--tabs"
                                    >
                                        <Tab label="Bond" value="1" />
                                        <Tab label="Redeem" value="2" />
                                    </TabList>
                                    </Box>
                                    <TabPanel value="1" className="px-0">
                                        <div>
                                            { useApprove ?
                                                <Grid
                                                    xs={12}
                                                    className="text-center pt-5 pb-4"
                                                >
                                                    <Link href="#" onClick={handleApprove} className="Global---menu-nav-btn px-5 py-2 mx-1">
                                                        Approve
                                                    </Link>
                                                </Grid>
                                            :
                                                <div>
                                                    <form className="position-relative">
                                                        { useAmountError ? 
                                                            <p 
                                                                className="text-left d-block text-danger mb-0 position-absolute "  
                                                                style={{top: '-1.3rem', left: '12px', fontSize: '13px'}}
                                                            >
                                                                Select a valid LP Token amount.
                                                            </p>
                                                        :
                                                            <p className="m-0" />
                                                        }
                                                        <div className="OS---form--stake d-md-flex mb-4 mt-4">
                                                            <label className="position-relative">
                                                                <input 
                                                                    type="number"
                                                                    className="mr-2"
                                                                    placeholder="Enter Amount"
                                                                    onChange={(event,type) =>handleAmount(event,'srch')}
                                                                    value={useAmount}
                                                                />
                                                                <Link
                                                                    type="button"
                                                                    onClick={(event,type) =>handleAmount(useTokenBalance,'max')}
                                                                >
                                                                    Max
                                                                </Link>
                                                            </label>
                                                            <Link 
                                                                href="#" 
                                                                onClick={handleBond}
                                                                className="Global---menu-nav-btn d-inline-block mt-3 mt-md-0 ml-2"
                                                            >
                                                                Bond
                                                            </Link>
                                                        </div>
                                                    </form>
                                                    
                                                    <DashboardList 
                                                        listTitle="Your Balance"
                                                        listValue= {(useUserBalance) + " LP"}
                                                    />
                                                    <DashboardList 
                                                        listTitle="You will get"
                                                        listValue= {(useDynamicYouWillGet) + "  Ohmni"}
                                                    />
                                                    <DashboardList 
                                                        listTitle="Max You Can Buy"
                                                        listValue= {(useMaxYouCanBuy) + " Ohmini" }
                                                    />
                                                    <DashboardList 
                                                        listTitle="ROI (5-Day Rate)"
                                                        listValue= {useRoi + "%"}
                                                    />
                                                    <DashboardList 
                                                        listTitle="Debt Ratio"
                                                        listValue= {(useDebtRatio) + "%" }
                                                    />
                                                    <DashboardList 
                                                        listTitle="Vesting Term"
                                                        listValue= {(useVestingTerm) + " days" }
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </TabPanel>
                                    <TabPanel value="2" className="px-0">
                                        <div>
                                            { useApprove ?
                                                <Grid
                                                    xs={12}
                                                    className="text-center pt-5 pb-4"
                                                >
                                                    <Link href="#" onClick={handleApprove} className="Global---menu-nav-btn px-5 py-2 mx-1">
                                                        Approve
                                                    </Link>
                                                </Grid>
                                            :
                                                <div>
                                                    <form className="position-relative">
                                                        <div className="OS---form--stake text-center d-sm-flex justify-content-center mb-4 mt-4">
                                                            <Link 
                                                                to="#" 
                                                                onClick={handleClaim}
                                                                className="Global---menu-nav-btn d-block mt-3 mt-md-0 mx-md-2 mx-auto"
                                                                style={{width: '-webkit-fill-available !important'}}
                                                            >
                                                                Claim
                                                            </Link>
                                                            <Link 
                                                                href="#" 
                                                                onClick={handleClaimAutoStake}
                                                                className="Global---menu-nav-btn d-block mt-3 mt-md-0 mx-md-2 mx-auto"
                                                                style={{width: '-webkit-fill-available !important'}}
                                                            >
                                                                Claim & Autostake
                                                            </Link>
                                                        </div>
                                                    </form>
                                                    
                                                    <DashboardList 
                                                        listTitle="Claimable Rewards"
                                                        listValue= {useYouWillGet + " Ohmini" }
                                                    />
                                                    <DashboardList 
                                                        listTitle="ROI (5-Day Rate)"
                                                        listValue= {useRoi + "%"}
                                                    />
                                                    <DashboardList 
                                                        listTitle="Debt Ratio"
                                                        listValue= {(useDebtRatio) + "%" }
                                                    />
                                                    <DashboardList 
                                                        listTitle="Vesting Term"
                                                        listValue= {(useVestingTerm) + " days" }
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </TabPanel>
                                </TabContext>
                            </Grid>
                        }
                    </Grid>
                </Box>
            </Modal>
        </Grid>
    )
}

export default DashboardTogetherCard;